import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
} from '@angular/core';
import { ConstantValues } from '../../../common/constant-values';
import { FundOutStatus } from '../../../models/fundout/fundout';

@Directive({
  selector: '[appStatusColor]',
})
export class StatusColorDirective implements OnChanges {
  @Input('appStatusColor') status: string = '';

  private readonly baseClass = 'badge';

  private readonly statusClassMap: Record<string, string> = {
    [ConstantValues.StaticValue.Pending.toLowerCase()]: 'badge-pending',
    [ConstantValues.StaticValue.InActive.toLowerCase()]: 'badge-pending',
    [ConstantValues.StaticValue.PendingApproval.toLowerCase()]: 'text-bg-warning',
    [ConstantValues.StaticValue.Deceased.toLowerCase()]: 'text-bg-secondary',

    [ConstantValues.StaticValue.True.toLowerCase()]: 'badge-approved',
    [ConstantValues.StaticValue.False.toLowerCase()]: 'badge-reject',
    [ConstantValues.StaticValue.Reverse.toLowerCase()]: 'text-bg-primary',
    [ConstantValues.StaticValue.RejectedFundout.toLowerCase()]: 'badge-reject',

    [ConstantValues.StaticValue.Success.toLowerCase()]: 'badge-approved',

    [ConstantValues.StaticValue.Active.toLowerCase()]: 'badge-approved',
    [ConstantValues.StaticValue.Approved.toLowerCase()]: 'badge-approved',
    [ConstantValues.StaticValue.LV1Approved.toLowerCase()]: 'badge-approved',
    [ConstantValues.StaticValue.LV2Approved.toLowerCase()]: 'badge-approved',
    [ConstantValues.StaticValue.PDLV1Approved.toLowerCase()]: 'badge-approved',
    [ConstantValues.StaticValue.PDL2Approved.toLowerCase()]: 'badge-approved',
  
    [ConstantValues.StaticValue.PDRejected.toLowerCase()]: 'badge-reject',
    [ConstantValues.StaticValue.PaymeRejected.toLowerCase()]: 'badge-reject',
    [ConstantValues.StaticValue.ExpiredLiveVerify.toLowerCase()]: 'badge-reject',
    [ConstantValues.StaticValue.Reject.toLowerCase()]: 'badge-reject',
    [ConstantValues.StaticValue.Rejected.toLowerCase()]: 'badge-reject',
    [ConstantValues.StaticValue.L1Rejected.toLowerCase()]: 'badge-reject',
    [ConstantValues.StaticValue.L2Rejected.toLowerCase()]: 'badge-reject',
    [ConstantValues.StaticValue.PDL1Rejected.toLowerCase()]: 'badge-reject',
    [ConstantValues.StaticValue.PDL2Rejected.toLowerCase()]: 'badge-reject',

  };

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(): void {
    this.updateStatusClass();
  }

  private updateStatusClass(): void {
    const normalizedStatus = this.status?.toLowerCase().trim() || '';
    const newClass = this.statusClassMap[normalizedStatus] || 'pending';

    // Remove all known status classes
    const allClasses = new Set(Object.values(this.statusClassMap));
    allClasses.add('pending');
    allClasses.add('d-none');

    allClasses.forEach(cls => this.renderer.removeClass(this.el.nativeElement, cls));
    this.renderer.removeClass(this.el.nativeElement, this.baseClass);

    // Add base class
    this.renderer.addClass(this.el.nativeElement, this.baseClass);

    // Add new status class or 'd-none' if no value
    if (!normalizedStatus) {
      this.renderer.addClass(this.el.nativeElement, 'd-none');
    } else {
      this.renderer.addClass(this.el.nativeElement, newClass);
    }
  }
}
